
import {ToastrService} from "ngx-toastr";
import {Usuarios} from "app/models/Usuario/usuarios.model";

import {UsuarioService} from "app/modules/admin/usuarios/usuario.service";
import {Component, OnInit, ViewEncapsulation, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TreoAnimations} from "@treo/animations";
import { Subscription, interval } from "rxjs";
import { Deposito } from "app/models/Usuario/deposito.model";
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
	selector: "app-dialog",
	templateUrl: "./dialog.component.html",
	styleUrls: ["./dialog.component.scss"],
	encapsulation: ViewEncapsulation.None,
	animations: TreoAnimations,
})
export class DialogComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<DialogComponent>,
		private usuarioService: UsuarioService,
		private toastr: ToastrService,
        private clipboard: Clipboard
	) {}
	usuario: Usuarios = JSON.parse(localStorage.getItem("usuario"));
	deposito: Deposito = new Deposito();
    subPix: Subscription = new Subscription();
    subPixAtivo: boolean = false;
	public carregando = false;
	public titulo: string;

	ngOnInit(): void {
		this.titulo = "Depósito";
        if(this.deposito.status == "Aberto"){
            this.verificarPixDeposito();
            this.subPixAtivo = true;
        }
	}

	fecharDialog() {
		this.dialogRef.close("Fechar");
	}

	salvar() {
        if (this.carregando) {
			this.toastr.info("Aguarde concluir o depósito", "Aguarde");
			return;
		}
		this.carregando = true;


		if (this.deposito.valor == null) {
			this.carregando = false;
			this.toastr.error("Por favor, escolha o valor do depósito!", "Erro");

			return;
		}


		this.usuarioService.novoDeposito(this.deposito).subscribe((response: Deposito) => {
            this.carregando = true;
            if (this.deposito.erro == true) {
				this.carregando = false;
				this.toastr.error(this.deposito.erroMensagem, "Erro");

				return;
			} else {
				this.deposito = response;
                this.carregando = false;
                this.verificarPixDeposito();
			}
		});

    }

    copiar(codigo: string) {
        this.clipboard.copy(codigo);
        this.toastr.success(
            "Código copiado com sucesso!",
            "Código"
        );
    }

    verificarPixDeposito(){
        if (this.subPixAtivo == false) {
            this.subPix = interval(5000).subscribe((x => {
                this.usuarioService.getDepositoId(this.deposito).subscribe((response) => {
                    var deposi: Deposito = JSON.parse(response);

                    if (deposi.status == "Pago") {
                        this.deposito = JSON.parse(response);
                        this.subPix.unsubscribe();
                    }
                });

            }));
        }

    }

	numeroParaReal(numero: any) {
		if (numero != undefined) {
			var numero = numero.toFixed(2).split(".");
			numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join(".");
			return numero.join(",");
		}
	}
}
